import api from '../lib/axios';

export const getDrafts = () => api.get('/drafts');
export const updateDraft = (id, data) => api.patch(`/drafts/${id}`, data);
export const approveDraft = (id) => api.post(`/drafts/${id}/approve`);
export const rejectDraft = (id) => api.post(`/drafts/${id}/reject`);
